import { useEffect } from 'react';
import { brandDetails } from '../../data/brandDetails';
import { About, Brands, Contact, HomeGallery } from '../../sections';

export default function Homepage() {
  useEffect(() => {
    // Update the document title using the browser API
    document.title = 'Prachurya Dash | Home';
  });

  return (
    <div className='page-homepage'>
      <HomeGallery />
      <Brands details={brandDetails} />
      <About />
      <Contact />
    </div>
  );
}
